export const getIsNationalAsParam = (): "0" | "1" => {
  const isNational =
    Boolean(window.nationalAccountInfoPayload) ||
    document.referrer.startsWith(`${window.location.origin}/national`);
  return isNational ? "1" : "0";
};
